import * as SliderPrimitive from '@radix-ui/react-slider';
import { cn } from '@/shared/lib/cn';
import './slider.scss';

export const Slider = ({
    className,
    max = 100,
    step = 1,
    defaultValue = [0],
    ...props
}: SliderPrimitive.SliderProps) => {
    return (
        <SliderPrimitive.Root
            className={cn('slider__root', className)}
            defaultValue={defaultValue}
            max={max}
            step={step}
            {...props}
        >
            <SliderPrimitive.Track className="slider__track">
                <SliderPrimitive.Range className="slider__range" />
            </SliderPrimitive.Track>
            <SliderPrimitive.Thumb className="slider__thumb" />
        </SliderPrimitive.Root>
    );
};
